import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import useExperienceYears from '../useExperienceYears';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { form, updateInProcess, handleCreateOrUpdate } =
    useExperienceYears(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('CREARE ANNI DI ESPERIENZA')
    : t('MODIFICA ANNI DI ESPERIENZA');

  const viewPage = pathname.replace('/edit', '');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
